import { createFileRoute } from '@tanstack/react-router';
import CreateFileNumber from '../../../features/baseData/fileNumbers/fileNumber/create';
import {
  createPermissionGuard,
  FILE_NUMBERS_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/aktenzeichen/neu')({
  component: CreateFileNumber,
  beforeLoad: createPermissionGuard(
    getPermissionSet(FILE_NUMBERS_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateFileNumberRoute = Route;
